import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { Fragment, useEffect, useState } from 'react';
import request from 'src/utils/request';
import loaderGif from '../common/no_bg_loader.gif';
import { DatePicker, LoadingButton, LocalizationProvider } from '@mui/lab';
import moment from 'moment';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { selectPolicyDetails } from 'src/features/rfqDataSlice';

const PremiumRequestPreview = ({
  sharePreview,
  preview,
  setPreview,
  loader,
  endorsementData,
  setShowSnackBarAlert,
  getEndorsementData
}) => {

  const policyDetailsData = useSelector(selectPolicyDetails);
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);
  const [walletStatusLoading, setWalletStatusLoading] = useState<boolean>(false);
  const [
    insuranceCompanyBranchSearchValue,
    setInsuranceCompanyBranchSearchValue
  ] = useState('');
  const [branchContactValue, setBranchContactValue] = useState<any>(null);
  const [insuranceCompanyBankSearchValue, setInsuranceCompanyBankSearchValue] =
    useState('');
  const [decision, setDecision] = useState(true);
  const [bankValue, setBankValue] = useState<any>(null);
  const [isAddingNewEmail, setIsAddingNewEmail] = useState(false);
  const [save, setSave] = useState<boolean>(true);
  const [premium, setPremium] = useState('0');
  const [netPremium, setNetPremium] = useState(0);
  const [gstPercentage, setGstPercentage] = useState(
    parseFloat(
      endorsementData?.gst ??
      endorsementData?.insurancePolicy?.placementSlip?.gst ??
      policyDetailsData?.placementSlip?.gst ??
      0
    )
  );

  const [gstInputValue, setGstInputValue] = useState(
    gstPercentage ? gstPercentage.toFixed(2) : ''
  );

  const [premiumType, setPremiumType] = useState<string>(endorsementData?.endorsementData?.type === 'Cancellation-Endorsement' ? 'REFUND' : 'PREMIUM_REQUIRED');
  const [paymentMode, setPaymentMode] = useState('BANK');
  const [customEmail, setCustomEmail] = useState(null);
  const [branchContactDatas, setBranchContactData] = useState([]);
  const [bankData, setBankData] = useState([]);
  const [branchContactSearchValue, setBranchContactSearchValue] = useState('');
  const [endorsementDetail, setEndorsementDetail] = useState(null);
  const [custPreview, setShowCustPreview] = useState<boolean>(false);
  const [previewData, setPreviewData] = useState<any>(null);

  useEffect(() => {
    if (premium && gstPercentage >= 0) {
      const gstAmount = (parseFloat(premium) * gstPercentage) / 100;
      setNetPremium(parseFloat(premium) + gstAmount);
    } else {
      setNetPremium(parseFloat(premium)); // fallback if GST missing
    }
  }, [premium, gstPercentage]);
  useEffect(() => {
    if (custPreview) {
      fetchPreview();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [custPreview]);
  useEffect(() => {
    if (endorsementData?.id) {
      fetchEndorsement();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endorsementData?.id]);
  useEffect(() => {
    if (paymentMode === 'BANK') {
      fetchBankData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMode, insuranceCompanyBankSearchValue]);
  useEffect(() => {
    if (
      (paymentMode === 'WALLET' && endorsementDetail !== null) ||
      (endorsementDetail?.paymentType === 'WALLET' &&
        preview.type === 'Approve Endorsement' && endorsementDetail?.type != 'Non-Financial')
    ) {
      // if (paymentMode === 'WALLET' && endorsementDetail !== null) {
      checkWalletAmount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    paymentMode,
    insuranceCompanyBankSearchValue,
    endorsementDetail?.paymentType
  ]);
  const checkWalletAmount = () => {
    setWalletStatusLoading(true);
    request({
      url: `endorsement/checkWalletStatus`,
      method: 'post',
      data: {
        endorsementId: endorsementDetail?.id,
        // amount: endorsementDetail?.premium
      }
    }).then(
      (response: any) => {
        if (response.status === true) {
          // setShowSnackBarAlert({
          //   status: true,
          //   type: 'success',
          //   message: response?.message
          // });
          setSave(true);
        } else {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: response?.message ? response?.message : 'Something went wrong'
          });
          setSave(false);
        }
        setWalletStatusLoading(false);
      },
      (error) => {
        setWalletStatusLoading(false);
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: error.message
        });
        setSave(false);
      }
    );
  };
  const fetchBankData = () => {
    setPreviewLoading(true);
    request({
      url: `companyBranchAccount/getCompanyBranchAccountList`,
      method: 'post',
      data: {
        search: insuranceCompanyBankSearchValue,
        orderColumn: 'branchName',
        orderDirection: 'ASC',
        offset: 0,
        limit: 25,
        companyBranchId: preview?.insuranceCompanyBranchId,
        status: true
      }
    }).then(
      (response: any) => {
        console.log('response::', response);
        setBankData(response.accountData);
        setPreviewLoading(false);
      },
      (error) => {
        setPreviewLoading(false);
        console.log(error);
      }
    );
  };
  const fetchEndorsement = () => {
    setPreviewLoading(true);
    request({
      url: `endorsement/getEndorsementById/${endorsementData?.id}`,
      method: 'get'
    }).then(
      (response: any) => {
        console.log('response::', response);
        setEndorsementDetail(response.data);
        formik.setValues((prev) => ({
          ...prev,
          bankName: response.data.bankAccountDetails?.bankName ?? null,
          accountNumber:
            response.data.bankAccountDetails?.accountNumber ?? null,
          ifscCode: response.data.bankAccountDetails?.ifscCode ?? null,
          city: response.data.bankAccountDetails?.city ?? null
        }));
        if (response.data.premiumStatus === 'REFUND') {
          setPaymentMode('WALLET');
        }
        setPreviewLoading(false);
      },
      (error) => {
        setPreviewLoading(false);
        console.log(error);
      }
    );
  };
  const fetchPreview = () => {
    setPreviewLoading(true);
    request({
      url: 'endorsement/getEndorsementMailPreview',
      method: 'post',
      data: {
        ids: preview.ids,
        type: preview.type,
        insuranceCompanyId: preview.insuranceCompanyId,
        paymentType:
          preview.type === 'PremiumRequset' || !bankValue?.id
            ? 'CASH'
            : paymentMode,
        insuranceCompanyBranchId: preview.insuranceCompanyBranchId,
        insuranceCompanyBranchContact: branchContactValue?.id ?? null,
        otherContact: preview?.customEmail ?? null,
        bankAccountId:
          bankValue?.id && paymentMode === 'BANK' ? bankValue?.id : null,
        showButton: false
      }
    }).then(
      (response: any) => {
        setPreviewData(response);
        setPreviewLoading(false);
      },
      (error) => {
        setPreviewLoading(false);
        console.log(error);
      }
    );
  };
  // const submitForm = () => {
  //   alert('form submitted');
  //   setShowCustPreview(true);
  // };

  useEffect(() => {
    console.log("preview", preview)
    if (preview.insuranceCompanyBranchId) {
      fetchCompanyContactList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchContactSearchValue, preview]);

  const fetchCompanyContactList = () => {
    request({
      url: 'icb-contacts/getIcbContactList',
      method: 'POST',
      data: {
        search: branchContactSearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 10000,
        // branchId: preview.branchId
        branchId: preview.insuranceCompanyBranchId
      }
    })
      .then((response: any) => {
        setBranchContactData(response?.contactData);
      })
      .catch(function (err) { });
  };

  const transactionSchema = Yup.object().shape({
    date: Yup.date().required('Date is required').typeError('Date is required'),
    // bank: Yup.string().required('Bank is required for refund').nullable(),
    // bankBranch: Yup.string()
    //   .required('Bank Branch is required for refund')
    //   .nullable(),
    referenceNumber: Yup.string()
      .required('Reference number is required for refund')
      .nullable()
  });

  const formik = useFormik({
    initialValues: {
      bankName: null,
      accountNumber: null,
      ifscCode: null,
      city: null,
      date: null,
      bankBranch: null,
      referenceNumber: ''
    },
    validationSchema: transactionSchema,
    onSubmit: async (values) => {
      handleApprovalSubmit(values);
    }
  });

  const handleApprovalSubmit = (values?: any) => {
    request({
      url: `endorsement/customerApproval`,
      method: 'post',
      data: {
        id: preview.ids,
        paymentType: endorsementDetail?.paymentType,
        paymentDetails: values
          ? {
            date: values.date,
            referenceNumber: values.referenceNumber,
            bankName: values.bankName,
            accountNumber: values.accountNumber,
            ifscCode: values.ifscCode,
            city: values.city,
            bankBranch: values.bankBranch
          }
          : null
      }
    })
      .then((response: any) => {
        setShowSnackBarAlert({
          status: true,
          type: 'success',
          message: response.message
        });
        setDecision(false);
        getEndorsementData();
      })
      .catch(function (err) {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
      });
  };

  const isValidEmailList = (emailString) => {
    if (!emailString) return false;

    const emails = emailString
      .split(',')
      .map(e => e.trim())
      .filter(Boolean);

    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emails.length > 0 && emails.every(email => emailRegex.test(email));
  };


  const emailSource = customEmail || branchContactValue?.email || "";

  const emailList = emailSource
    .split(",")
    .map((e: string) => e.trim())
    .filter(Boolean);

  const toEmail = emailList[0] || "";
  const ccEmails = emailList.slice(1).join(", ");


  return (
    <Dialog
      open={preview.status}
      onClose={() =>
        setPreview({
          status: false,
          type: null,
          insuranceCompanyId: null,
          branchId: null,
          insuranceCompanyBranchId: null,
          insuranceCompanyBranchContact: null,
          otherContact: null,
          ids: null,
          endorsementType: null,
          premiumStatus: null,
          endorsementData: null
        })
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={preview.type === 'Approve Endorsement' ? false : 'lg'}
      fullWidth
      fullScreen={preview.type === 'Approve Endorsement'}
      scroll="body"
    >
      {(preview.type === 'PremiumRequsetToCustomer' &&
        // (preview.endorsementType === 'Financial' ||
        //   preview.endorsementType === 'Both')
        // &&
        !custPreview) ||
        preview.type === 'Approve Endorsement' ? (
        <>
          <DialogTitle id="alert-dialog-title">
            <strong>{preview.endorsementType} - View</strong>
          </DialogTitle>
          <DialogContent
            sx={{
              p: 0,
              overflow: 'visible',
              maxHeight: 'none'
            }}
          >
            <Box sx={{ p: 2 }}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#d6eadf' }}>
                      <TableCell>
                        <strong>Item</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Sum Insured</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Premium</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Tax</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Total premium</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Effective date</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {/* Initial row */}
                    <TableRow>
                      <TableCell>Initial Sum Insured</TableCell>
                      <TableCell>
                        ₹ {parseFloat(endorsementDetail?.insurancePolicy?.sumInsured ?? 0).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ₹ {parseFloat(endorsementDetail?.insurancePolicy?.totalPremium ?? 0).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ₹ {parseFloat(endorsementDetail?.insurancePolicy?.gstAmount ?? 0).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ₹{' '}
                        {(
                          Number(endorsementDetail?.insurancePolicy?.totalPremium || 0) +
                          Number(endorsementDetail?.insurancePolicy?.gstAmount || 0)
                        ).toFixed(2)}
                      </TableCell>

                      <TableCell>
                        {endorsementDetail?.insurancePolicy?.policyStartDate
                          ? moment(
                            endorsementDetail?.insurancePolicy
                              ?.policyStartDate
                          ).format('DD-MM-YYYY')
                          : ''}
                      </TableCell>
                    </TableRow>

                    {/* Previous endorsements */}
                    {endorsementDetail?.previousEndorsements?.map(
                      (data, idx) => (
                        <TableRow key={idx}>
                          <TableCell>Endorsed Sum Insured</TableCell>
                          <TableCell>₹ {parseFloat(data?.sumInsured ?? 0).toFixed(2)}</TableCell>
                          <TableCell>₹ {parseFloat(data?.premium ?? 0).toFixed(2)}</TableCell>
                          <TableCell>₹ {parseFloat(data?.tax ?? 0).toFixed(2)}</TableCell>
                          <TableCell>
                            ₹{' '}
                            {(Number(data?.premium || 0) +
                              Number(data?.tax || 0)).toFixed(2)}
                          </TableCell>
                          <TableCell>
                            {data?.endorsementEffectiveDate
                              ? moment(data?.endorsementEffectiveDate).format(
                                'DD-MM-YYYY'
                              )
                              : ''}
                          </TableCell>
                        </TableRow>
                      )
                    )}

                    {/* Highlighted current endorsement */}
                    <TableRow sx={{ backgroundColor: '#fce4ec' }}>
                      <TableCell>
                        <strong>Endorsed Sum Insured</strong>
                      </TableCell>
                      <TableCell>₹ {parseFloat(endorsementDetail?.sumInsured ?? 0)?.toFixed(2)}</TableCell>
                      <TableCell>₹ {parseFloat(endorsementDetail?.premium ?? 0)?.toFixed(2)}</TableCell>
                      <TableCell>₹ {parseFloat(endorsementDetail?.tax ?? 0)?.toFixed(2)}</TableCell>
                      <TableCell>
                        ₹{' '}
                        {(Number(endorsementDetail?.premium || 0) +
                          Number(endorsementDetail?.tax || 0))?.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {endorsementDetail?.endorsementEffectiveDate
                          ? moment(
                            endorsementDetail?.endorsementEffectiveDate
                          ).format('DD-MM-YYYY')
                          : ''}
                      </TableCell>
                    </TableRow>

                    {/* Total row */}
                    <TableRow sx={{ backgroundColor: '#e0e0e0' }}>
                      <TableCell>
                        <strong>Total</strong>
                      </TableCell>
                      <TableCell>
                        ₹{" "}
                        {/* {(
                          Number(endorsementDetail?.insurancePolicy?.sumInsured || 0) +
                          (endorsementDetail?.previousEndorsements?.reduce(
                            (acc, item) => acc + Number(item?.sumInsured || 0),
                            0
                          ) || 0) +
                          Number(endorsementDetail?.sumInsured || 0)
                        ).toFixed(2)} */}
                        {parseFloat(endorsementDetail?.sumInsured ?? 0)?.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ₹{" "}
                        {(
                          Number(endorsementDetail?.insurancePolicy?.totalPremium || 0) +
                          (endorsementDetail?.previousEndorsements?.reduce(
                            (acc, item) => acc + Number(item?.premium || 0),
                            0
                          ) || 0) +
                          Number(endorsementDetail?.premium || 0)
                        ).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ₹{" "}
                        {(
                          Number(endorsementDetail?.insurancePolicy?.gstAmount || 0) +
                          (endorsementDetail?.previousEndorsements?.reduce(
                            (acc, item) => acc + Number(item?.tax || 0),
                            0
                          ) || 0) +
                          Number(endorsementDetail?.tax || 0)
                        ).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ₹{" "}
                        {(
                          Number(endorsementDetail?.insurancePolicy?.totalPremium || 0) +
                          Number(endorsementDetail?.insurancePolicy?.gstAmount || 0) +
                          (endorsementDetail?.previousEndorsements?.reduce(
                            (acc, item) =>
                              acc +
                              Number(item?.premium || 0) +
                              Number(item?.tax || 0),
                            0
                          ) || 0) +
                          Number(endorsementDetail?.premium || 0) +
                          Number(endorsementDetail?.tax || 0)
                        ).toFixed(2)}
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Divider />
            {preview.type !== 'Approve Endorsement' ? (
              <Grid container spacing={2} sx={{ mt: 2, p: 2 }}>
                {endorsementDetail?.premium &&
                  endorsementDetail?.premium !== '0' &&
                  endorsementDetail?.premium !== null ? (
                  <>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="payment-mode-label">
                          Select Payment Mode{' '}
                          <Typography component="span" sx={{ color: 'red' }}>
                            *
                          </Typography>
                        </InputLabel>
                        <Select
                          labelId="payment-mode-label"
                          id="payment-mode"
                          value={paymentMode}
                          label="Select Payment Mode"
                          onChange={(e) => {
                            setPaymentMode(e.target.value);
                            setSave(true);
                          }}
                        >
                          <MenuItem
                            value="BANK"
                            disabled={
                              endorsementDetail?.premiumStatus === 'REFUND'
                            }
                          >
                            Bank Account
                          </MenuItem>
                          <MenuItem value="WALLET">Wallet</MenuItem>
                          {/* <MenuItem value="CASH">Cash</MenuItem> */}
                        </Select>
                      </FormControl>
                    </Grid>

                    {endorsementDetail?.premiumStatus === 'PREMIUM_REQUIRED' ? (
                      <>
                        {paymentMode === 'BANK' && (
                          <Grid item xs={12} md={6}>
                            <Autocomplete
                              size="small"
                              disableClearable={
                                insuranceCompanyBankSearchValue ? false : true
                              }
                              id="bankId"
                              getOptionLabel={(companyData) =>
                                `${companyData.bankName} (${companyData.accountNumber}-${companyData.city})`
                              }
                              options={bankData}
                              inputValue={insuranceCompanyBankSearchValue}
                              noOptionsText="No Data Found"
                              onChange={(event: any, newValue: any) => {
                                if (newValue) {
                                  setBankValue(newValue);
                                  setInsuranceCompanyBankSearchValue(
                                    `${newValue.bankName} (${newValue.accountNumber}-${newValue.city})`
                                    // newValue.bankName
                                  );
                                  setSave(true);
                                } else {
                                  setBankValue(null);
                                  setInsuranceCompanyBankSearchValue('');
                                }
                              }}
                              onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'input') {
                                  setInsuranceCompanyBankSearchValue(
                                    newInputValue
                                  );
                                  if (newInputValue === '') {
                                    setBankValue('');
                                  }
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  value={bankValue}
                                  {...params}
                                  label={
                                    <>
                                      Insurance Company Bank Account{' '}
                                      <Typography
                                        component="span"
                                        sx={{ color: 'red' }}
                                      >
                                        *
                                      </Typography>
                                    </>
                                  }
                                  name="bankValue"
                                />
                              )}
                            />
                          </Grid>
                        )}
                      </>
                    ) : null}
                  </>
                ) : null}
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{ ml: 1 }}
                        checked={isAddingNewEmail}
                        onChange={(e) => {
                          setIsAddingNewEmail(e.target.checked);
                          if (!e.target.checked) {
                            setCustomEmail(null);
                          }
                        }}
                      />
                    }
                    label="Send to a Different Email ID"
                  />
                </Grid>
                {isAddingNewEmail && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label={
                        <>
                          Enter New Email ID{' '}
                          <Typography component="span" sx={{ color: 'red' }}>
                            *
                          </Typography>
                        </>
                      }
                      name="customEmail"
                      value={customEmail}
                      onChange={(e) => setCustomEmail(e.target.value)}
                    />
                  </Grid>
                )}
              </Grid>
            ) : null}
          </DialogContent>
          <DialogActions>
            {preview.type === 'Approve Endorsement' ? (
              <Box sx={{ width: '100%' }}>
                {endorsementDetail?.bankAccountDetails ? (
                  <>
                    <Card sx={{ mb: 4 }}>
                      <Divider />
                      <CardContent>
                        <form onSubmit={formik.handleSubmit}>
                          <Grid container spacing={3} alignItems="stretch">

                            <Grid item xs={12} md={4}>

                              <Typography color="textSecondary">
                                Account Number
                              </Typography>
                              <Typography variant="body2">
                                {formik.values.accountNumber || "N/A"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <Typography color="textSecondary">
                                Bank Name
                              </Typography>
                              <Typography variant="body2">
                                {formik.values.bankName || "N/A"}
                              </Typography>
                            </Grid>

                            {/* <Grid item xs={12} md={4}>
                              <Typography variant="caption" color="textSecondary">
                                Bank Branch
                              </Typography>
                              <Typography variant="body2">
                                {formik.values.bankBranch || "-"}
                              </Typography>
                            </Grid> */}

                            <Grid item xs={12} md={4}>
                              <Typography color="textSecondary">
                                IFSC Code
                              </Typography>
                              <Typography variant="body2">
                                {formik.values.ifscCode || "N/A"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <Typography color="textSecondary">
                                City
                              </Typography>
                              <Typography variant="body2">
                                {formik.values.city || "N/A"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <DatePicker
                                  views={['year', 'month', 'day']}
                                  inputFormat="dd-MM-yyyy"
                                  label={
                                    <>
                                      Date{' '}
                                      <Typography
                                        component="span"
                                        sx={{ color: 'red' }}
                                      >
                                        *
                                      </Typography>
                                    </>
                                  }
                                  value={formik.values.date}
                                  onChange={(newValue) => {
                                    formik.setFieldValue('date', newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      name="date"
                                      size="small"
                                      error={
                                        formik.touched.date &&
                                        Boolean(formik.errors.date)
                                      }
                                      helperText={
                                        formik.touched.date &&
                                        formik.errors.date
                                      }
                                    />
                                  )}
                                  maxDate={new Date()}
                                />
                              </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                size="small"
                                name="referenceNumber"
                                label={
                                  <>
                                    Reference Number{' '}
                                    <Typography
                                      component="span"
                                      sx={{ color: 'red' }}
                                    >
                                      *
                                    </Typography>
                                  </>
                                }
                                value={formik.values.referenceNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.referenceNumber &&
                                  Boolean(formik.errors.referenceNumber)
                                }
                                helperText={
                                  formik.touched.referenceNumber &&
                                  formik.errors.referenceNumber
                                }
                              />
                            </Grid>
                          </Grid>
                        </form>
                      </CardContent>
                    </Card>
                  </>
                ) : null}
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 2,
                    mb: 4
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (
                        // endorsementDetail?.paymentType === 'BANK' &&
                        endorsementDetail?.bankAccountDetails
                      ) {
                        formik.handleSubmit();
                      } else {
                        handleApprovalSubmit();
                        setDecision(false);
                      }
                    }}
                    disabled={!decision || !save || !endorsementDetail || walletStatusLoading}
                  >
                    Approve
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() =>
                      setPreview({
                        status: false,
                        type: null,
                        insuranceCompanyId: null,
                        branchId: null,
                        insuranceCompanyBranchId: null,
                        insuranceCompanyBranchContact: null,
                        otherContact: null,
                        ids: null,
                        endorsementType: null,
                        premiumStatus: null,
                        endorsementData: null
                      })
                    }
                  >
                    Close
                  </Button>
                </Box>
              </Box>
            ) : (
              <>
                <LoadingButton
                  onClick={() => {
                    if (
                      customEmail &&
                      !isValidEmailList(customEmail)
                    ) {
                      setShowSnackBarAlert({
                        status: true,
                        type: 'error',
                        message:
                          'Please enter a valid email address. Multiple emails can be comma separated.'
                      });
                      return;
                    }
                    if (preview.type === 'PremiumEnter') {
                      if (gstPercentage != null && gstPercentage >= 0) {
                        sharePreview(
                          preview.type,
                          branchContactValue?.id ?? null,
                          customEmail ?? null,
                          premium ?? null,
                          premium ? premiumType : null,
                          paymentMode ?? null,
                          paymentMode === 'BANK' ? bankValue?.id : null,
                          gstPercentage
                        );
                      }
                    } else {
                      setShowCustPreview(true);
                    }
                  }}
                  variant="contained"
                  loading={loader}
                  color="primary"
                  disabled={
                    (isAddingNewEmail && !customEmail) ||
                    !save ||
                    (
                      paymentMode === 'BANK' &&
                      !bankValue &&
                      Number(endorsementDetail?.premium) > 0 &&
                      endorsementDetail?.premiumStatus === 'PREMIUM_REQUIRED'
                    )
                  }
                >
                  Save
                </LoadingButton>

                <Button
                  onClick={() =>
                    setPreview({
                      status: false,
                      type: null,
                      insuranceCompanyId: null,
                      branchId: null,
                      insuranceCompanyBranchId: null,
                      insuranceCompanyBranchContact: null,
                      otherContact: null,
                      ids: null,
                      endorsementType: null,
                      premiumStatus: null,
                      endorsementData: null
                    })
                  }
                  variant="contained"
                  color="error"
                >
                  Close
                </Button>
              </>
            )}
          </DialogActions>
        </>
      ) : (
        <>
          {custPreview || preview.type === 'PremiumRequsetToCustomer' ? (
            <>
              <DialogTitle id="alert-dialog-title">Mail Preview</DialogTitle>
              <DialogContent
                sx={{
                  p: 0,
                  overflow: 'visible',
                  maxHeight: 'none'
                }}
              >
                {previewLoading ? (
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow style={{ backgroundColor: 'transparent' }}>
                          <TableCell align="center">
                            <img
                              alt="loader"
                              src={loaderGif}
                              className="loader"
                              width={100}
                              height={100}
                            />
                          </TableCell>
                        </TableRow>
                      </TableHead>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    {(preview.type === 'PremiumRequset' ||
                      preview.type === 'PremiumRequsetToCustomer') &&
                      (customEmail || branchContactValue?.email) ? (
                      <> <Typography variant="subtitle1" fontWeight={500} mb={1}>
                        Mail To: {toEmail}
                      </Typography>

                        {ccEmails && (
                          <Typography variant="subtitle1" fontWeight={500} mb={1}>
                            CC: {ccEmails}
                          </Typography>
                        )}</>
                    ) : null}
                    <iframe
                      title="HTML Preview"
                      srcDoc={previewData}
                      style={{
                        display: 'block',
                        width: '100%',
                        border: 'none',
                        minHeight: '500px'
                      }}
                    />
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setShowCustPreview(false);
                  }}
                  disabled={loader}
                  variant="contained"
                  color="primary"
                >
                  Go Back
                </Button>
                <LoadingButton
                  onClick={() =>
                    sharePreview(
                      preview.type,
                      branchContactValue?.id ?? null,
                      customEmail ?? null,
                      premium ?? null,
                      premium ? premiumType : null,
                      paymentMode ?? null,
                      paymentMode === 'BANK' ? bankValue?.id : null
                    )
                  }
                  variant="contained"
                  loading={loader}
                  color="primary"
                >
                  Submit
                </LoadingButton>
                <Button
                  onClick={() =>
                    setPreview({
                      status: false,
                      type: null,
                      insuranceCompanyId: null,
                      branchId: null,
                      insuranceCompanyBranchId: null,
                      insuranceCompanyBranchContact: null,
                      otherContact: null,
                      ids: null,
                      endorsementType: null,
                      premiumStatus: null,
                      endorsementData: null
                    })
                  }
                  variant="contained"
                  color="error"
                >
                  Close
                </Button>
              </DialogActions>
            </>
          ) : (
            <>
              <DialogTitle id="alert-dialog-title">
                <strong>
                  {preview.type !== 'PremiumRequset'
                    ? 'Enter Premium'
                    : 'Share To'}
                </strong>
              </DialogTitle>
              <DialogContent
                sx={{
                  p: 0,
                  overflow: 'visible',
                  maxHeight: 'none'
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Grid container spacing={2}>
                    {preview.type !== 'PremiumRequset' ? (
                      <>

                        <Grid item xs={4}>
                          <FormControl component="fieldset">
                            <FormLabel component="legend">
                              {
                                <>
                                  Premium Type{' '}
                                  <Typography
                                    component="span"
                                    sx={{ color: 'red' }}
                                  >
                                    *
                                  </Typography>
                                </>
                              }
                            </FormLabel>
                            <RadioGroup
                              row
                              name="premiumType"
                              value={premiumType}
                              onChange={(e) => {
                                setPremiumType(e.target.value);
                                setPremium('0');
                              }}
                            >
                              <FormControlLabel
                                value="PREMIUM_REQUIRED"
                                control={<Radio />}
                                label="Payment"
                                disabled={endorsementData?.endorsementData?.type === 'Cancellation-Endorsement'}
                              />
                              <FormControlLabel
                                value="REFUND"
                                control={<Radio />}
                                label="Refund"
                              />
                              <FormControlLabel
                                value="NO_PREMIUM"
                                control={<Radio />}
                                label="No Premium"
                                disabled={endorsementData?.endorsementData?.type === 'Cancellation-Endorsement'}
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3} mr={2} mt={2}>
                          <TextField
                            sx={{ width: '100%' }}
                            label={
                              <>
                                Premium (Without GST) {' '}
                                {premiumType !== 'NO_PREMIUM' ? (
                                  <Typography component="span" sx={{ color: 'red' }}>
                                    *
                                  </Typography>
                                ) : null}
                              </>
                            }
                            disabled={premiumType === 'NO_PREMIUM'}
                            name="premium"
                            type="number"
                            value={premium}
                            onChange={(e) => {
                              const value = e.target.value;
                              // ✅ Allow only positive numbers or empty string
                              if (value === '' || parseFloat(value) >= 0) {
                                setPremium(value);
                              }
                            }}
                            onKeyDown={(e) => {
                              // ✅ Block minus, plus, and exponential input
                              if (['-', '+', 'e', 'E'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            size="small"
                          />


                        </Grid>
                        <Grid item xs={2} mr={2} mt={2}>

                          <TextField
                            sx={{ width: '100%' }}
                            label={
                              <>
                                GST %{' '}
                                {premiumType !== 'NO_PREMIUM' && (
                                  <Typography component="span" sx={{ color: 'red' }}>
                                    *
                                  </Typography>
                                )}
                              </>
                            }
                            disabled={premiumType === 'NO_PREMIUM'}
                            name="gst_percentage"
                            type="text"
                            value={gstInputValue}
                            onChange={(e) => {
                              const value = e.target.value;

                              // Allow only digits and one dot, and max 2 digits after decimal
                              if (/^\d*\.?\d{0,2}$/.test(value)) {
                                setGstInputValue(value);
                              }
                            }}
                            onBlur={() => {
                              if (gstInputValue !== '') {
                                const parsed = parseFloat(gstInputValue);
                                if (!isNaN(parsed)) {
                                  setGstPercentage(parsed); // update numeric state
                                  setGstInputValue(parsed.toFixed(2)); // show formatted text
                                }
                              } else {
                                setGstPercentage(null);
                                setGstInputValue(null);
                              }
                            }}
                            size="small"
                            error={
                              premiumType !== 'NO_PREMIUM' &&
                              (gstInputValue?.trim() === '' || isNaN(parseFloat(gstInputValue)))
                            }
                            helperText={
                              premiumType !== 'NO_PREMIUM' &&
                                (gstInputValue?.trim() === '' || isNaN(parseFloat(gstInputValue)))
                                ? 'GST % is required'
                                : ''
                            }
                          />



                        </Grid>
                        <Grid item xs={2} mr={2} mt={2}>

                          <TextField
                            sx={{ width: '100%' }}
                            label={
                              <>
                                Net Premium {' '}
                                {premiumType !== 'NO_PREMIUM' ? (
                                  <Typography
                                    component="span"
                                    sx={{ color: 'red' }}
                                  >
                                    *
                                  </Typography>
                                ) : null}
                              </>
                            }
                            disabled={true}
                            name="net_premium"
                            type="number"
                            value={netPremium?.toFixed(2)}
                            onChange={(e) => setNetPremium(parseFloat(e.target.value))}
                            size="small"
                          />
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid item xs={5} ml={1}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                sx={{ ml: 1 }}
                                checked={isAddingNewEmail}
                                onChange={(e) => {
                                  setIsAddingNewEmail(e.target.checked);
                                  if (e.target.checked) {
                                    setBranchContactValue(null);
                                    setBranchContactData([]);
                                    setBranchContactSearchValue('');
                                    setInsuranceCompanyBranchSearchValue('');
                                  } else {
                                    setCustomEmail(null);
                                    fetchCompanyContactList();
                                  }
                                }}
                              />
                            }
                            label="Send to a Different Email ID"
                          />
                        </Grid>

                        {!isAddingNewEmail ? (
                          <Grid item xs={5} mr={1}>
                            <Autocomplete
                              size={'small'}
                              disableClearable={
                                insuranceCompanyBranchSearchValue ? false : true
                              }
                              id="insuranceCompanyBranchContactId"
                              getOptionLabel={(companyData) =>
                                ` ${companyData.firstName} ${companyData.lastName} (${companyData.email})`
                              }
                              disabled={
                                preview.insuranceCompanyId && !isAddingNewEmail
                                  ? false
                                  : true
                              }
                              options={branchContactDatas}
                              inputValue={branchContactSearchValue}
                              noOptionsText={'No Data Found'}
                              onChange={(event: any, newValue: any) => {
                                console.log('newValue:', newValue);
                                if (newValue) {
                                  setBranchContactValue(newValue);
                                  setBranchContactSearchValue(
                                    ` ${newValue.firstName} ${newValue.lastName} (${newValue.email})`
                                  );
                                } else {
                                  setBranchContactValue(null);
                                  setBranchContactSearchValue('');
                                }
                              }}
                              onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'input') {
                                  setBranchContactSearchValue(newInputValue);
                                  if (newInputValue === '') {
                                    setBranchContactValue('');
                                  }
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  value={` ${branchContactValue?.firstName} ${branchContactValue?.lastName} (${branchContactValue?.email})`}
                                  // value={branchContactValue}
                                  {...params}
                                  label={
                                    <>
                                      Insurer Branch Contact{' '}
                                      <Typography
                                        component="span"
                                        sx={{ color: 'red' }}
                                      >
                                        *
                                      </Typography>
                                    </>
                                  }
                                  name="branchContactValue"
                                />
                              )}
                            />
                          </Grid>
                        ) : (
                          <Grid item xs={5} mr={1}>
                            {isAddingNewEmail && (
                              <TextField
                                sx={{ width: '100%' }}
                                label={
                                  <>
                                    Enter New Email ID{' '}
                                    <Typography
                                      component="span"
                                      sx={{ color: 'red' }}
                                    >
                                      *
                                    </Typography>
                                  </>
                                }
                                name="customEmail"
                                value={customEmail}
                                onChange={(e) => setCustomEmail(e.target.value)}
                                size="small"
                              />
                            )}
                          </Grid>
                        )}
                      </>
                    )}
                  </Grid>
                </Box>
              </DialogContent>
              <DialogActions>
                <LoadingButton
                  onClick={() => {
                    if (
                      customEmail &&
                      !isValidEmailList(customEmail)
                    ) {
                      setShowSnackBarAlert({
                        status: true,
                        type: 'error',
                        message:
                          'Please enter a valid email address. Multiple emails can be comma separated.'
                      });
                      return;
                    }
                    if (preview.type !== 'PremiumEnter') {
                      setShowCustPreview(true);
                    } else {

                      if (gstPercentage != null) {
                        sharePreview(
                          preview.type,
                          branchContactValue?.id ?? null,
                          customEmail ?? null,
                          premium ?? null,
                          premium ? premiumType : null,
                          paymentMode ?? null,
                          paymentMode === 'BANK' ? bankValue?.id : null,
                          gstPercentage
                        );
                      }




                    }
                  }}
                  variant="contained"
                  loading={loader}
                  color="primary"
                  disabled={
                    (preview.type !== 'PremiumRequset' &&
                      !premium &&
                      premiumType !== 'NO_PREMIUM') ||
                    (preview.type === 'PremiumRequset' &&
                      !customEmail &&
                      !branchContactValue?.email)
                  }
                >
                  Save
                </LoadingButton>
                <Button
                  onClick={() =>
                    setPreview({
                      status: false,
                      type: null,
                      insuranceCompanyId: null,
                      branchId: null,
                      insuranceCompanyBranchId: null,
                      insuranceCompanyBranchContact: null,
                      otherContact: null,
                      ids: null,
                      endorsementType: null,
                      premiumStatus: null,
                      endorsementData: null
                    })
                  }
                  variant="contained"
                  color="error"
                >
                  Close
                </Button>
              </DialogActions>
            </>
          )}
        </>
      )}
    </Dialog>
  );
};
export default PremiumRequestPreview;

PremiumRequestPreview.propTypes = {
  cancelopen: PropTypes.bool,
  cancelType: PropTypes.string,
  closeCancelModal: PropTypes.func,
  cancelPolicyRequest: PropTypes.func
};
